import { on } from "delegated-events";
import easydropdown from "easydropdown-a11y";
import "@styles/components/dropdown.css";
import ajax from "@common/ajax";
import { scrollToIfNeeded } from "@common/scroll-to";
import { generateQueryString } from "@common/util";
import Swiper from "swiper";
import { A11y, Autoplay, Pagination } from "swiper/modules";
import "@styles/components/slider.css";
import pillList from "@scripts/components/pill-list";

const form = document.querySelector(".filter-form");

const setupDropdown = (el) => {
  if (el.tagName !== "SELECT") {
    return;
  }

  const opts = {
    behavior: {
      openOnFocus: true,
      maxVisibleItems: 10,
      liveUpdates: true,
      useNativeUiOnMobile: false,
    },
  };

  easydropdown(el, opts);
};

const handleFilterChange = (e) => {
  e.preventDefault();

  const params = new FormData(form);
  const queryString = generateQueryString(params);
  const url = queryString.size ? `${form.action}?${queryString}` : form.action;

  window.history.replaceState({}, "", url);

  updateResults();
};

const handleFilterClear = () => {
  form.reset();
  form.querySelectorAll("select").forEach((x) => (x.value = ""));

  window.history.replaceState({}, "", form.action);

  updateResults();
};

const updateResults = async () => {
  const pageContent = document.querySelector("[data-page-content]");

  pageContent.classList.add("is-loading");

  const res = await ajax.get(window.location.href).json();

  pageContent.innerHTML = res.page;
  pageContent.classList.remove("is-loading");

  if (res.isFiltered) {
    form.classList.add("is-filtered");
    scrollToIfNeeded(pageContent);
  } else {
    form.classList.remove("is-filtered");
  }

  setupFeaturedTestimonials();
};

const setupFeaturedTestimonials = () => {
  const el = document.querySelector(".featured-testimonials");

  if (el) {
    const container = el.querySelector(".swiper");
    const numSlides = el.querySelectorAll(".swiper-slide").length;

    new Swiper(container, {
      modules: [A11y, Autoplay, Pagination],
      slidesPerView: 1,
      autoplay: {
        delay: 5000,
        pauseOnMouseEnter: true,
      },
      loop: true,
      speed: 1000,
      pagination: {
        el: el.querySelector(".slider-pagination"),
        clickable: true,
      },
      watchSlidesProgress: numSlides <= 3,
      breakpoints: {
        768: {
          centeredSlides: numSlides >= 3,
          slidesPerView: 2,
        },
        1700: {
          centeredSlides: numSlides > 3,
          slidesPerView: 3,
        },
      },
    });
  }
};

const init = () => {
  if (form) {
    form.querySelectorAll("select:not([multiple])").forEach((el) => setupDropdown(el));

    const filterPills = form.querySelector("[data-pill-list]");

    if (filterPills) {
      pillList.init(filterPills);
    }

    on("change", ".filter-form select", handleFilterChange);
    on("change", '.filter-form input[type="radio"]', (e) => {
      handleFilterChange(e);
      pillList.animatePillMarker(filterPills);
    });
    on("submit", ".filter-form", handleFilterChange);
    on("click", ".filter-form-clear", () => {
      handleFilterClear();
      pillList.animatePillMarker(filterPills);
    });

    const handleFilterVisibility = () => {
      if (window.matchMedia("(min-width: 768px)").matches) {
        form.querySelectorAll("select").forEach((el) => (el.disabled = true));
        form.querySelectorAll('input[type="radio"]').forEach((el) => (el.disabled = false));
      } else {
        form.querySelectorAll("select").forEach((el) => (el.disabled = false));
        form.querySelectorAll('input[type="radio"]').forEach((el) => (el.disabled = true));
      }
    };

    handleFilterVisibility();

    window.addEventListener("resize", handleFilterVisibility);
  }

  setupFeaturedTestimonials();
};

init();
